import { FiltersParams } from 'types/params';
import { ModifiersWithTotal } from '../types';

const convertFilterToModifiersWithTotal = (
    filters: [string, number][],
    params: FiltersParams,
) =>
    filters.map(([code, total]): ModifiersWithTotal => [[params, code], total]);

export default convertFilterToModifiersWithTotal;
